import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { LoginAccessFiles, LoginClaimDamage, LoginSendMessage, LoginSignContracts } from "@/assets/images";

import { StyledWrapperWhatCanBeDone } from "./styled";

const WhatCanBeDoneWithMyBroker: FC = () => {
    const { t } = useTranslation();

    return (
        <div style={{ marginTop: "20px" }}>
            <h2 className="hidden-on-mobile">{t("Login.WhatCanBeDone.Title")}</h2>
            <StyledWrapperWhatCanBeDone>
                <div className="item">
                    <div className="item-image">
                        <LoginAccessFiles className="img" />
                    </div>
                    <div className="item-text">
                        <div className="item-title">{t("Login.WhatCanBeDone.AccessFiles.Title")}</div>
                        <div className="item-message">{t("Login.WhatCanBeDone.AccessFiles.Message")}</div>
                    </div>
                </div>
                <div className="item">
                    <div className="item-image">
                        <LoginSignContracts className="img" />
                    </div>
                    <div className="item-text">
                        <div className="item-title">{t("Login.WhatCanBeDone.SignContracts.Title")}</div>
                        <div className="item-message">{t("Login.WhatCanBeDone.SignContracts.Message")}</div>
                    </div>
                </div>

                <div className="item">
                    <div className="item-image">
                        <LoginClaimDamage className="img" />
                    </div>
                    <div className="item-text">
                        <div className="item-title">{t("Login.WhatCanBeDone.ClaimDamage.Title")}</div>
                        <div className="item-message">{t("Login.WhatCanBeDone.ClaimDamage.Message")}</div>
                    </div>
                </div>

                <div className="item">
                    <div className="item-image">
                        <LoginSendMessage className="img" />
                    </div>
                    <div className="item-text">
                        <div className="item-title">{t("Login.WhatCanBeDone.SendMessage.Title")}</div>
                        <div className="item-message">{t("Login.WhatCanBeDone.SendMessage.Message")}</div>
                    </div>
                </div>
            </StyledWrapperWhatCanBeDone>
        </div>
    );
};

export default WhatCanBeDoneWithMyBroker;
